export default {
    caseStudies:[],
    active_case_study:null,
    fetching_case_study:false,
    caseStudyId:null,
    editCaseStudy:false,
    fetch_case_studies_list:false,
}
